module.exports = __webpack_public_path__ + "img/share-icon-music-select.0cb5dc50.svg";